/**
 * useQueryInfoQuery
 */

import _get from 'lodash/get';

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';
import { useMediaConfig } from 'bdvp-common/src/hooks/config';

import parseQueryInfo from '../../utils/parseQueryInfo';
import overrideFilters from '../../utils/overrideFilters';
import useSelectedFiltersStore from './useSelectedFiltersStore';
import useSearchSort from './useSearchSort';
import useFiltersConfig from '../useFiltersConfig';

const {
    useQuery,
    useApolloClient,
} = ApolloLib;

const {
    GET_QUERY_INFO,
    GET_CONTENT_TAG_DISPLAY_VALUES,
} = Queries;

const CONTENT_TAGS_FIELD_ID = 169;

const useQueryInfoQuery = (queries, queryType, options = {}) => {

    queries = queries || ''; // we use es5 to set the default value because `queries` might be passed as null
    const {
        skip = false,
    } = options;
    const { setSelectedFilters } = useSelectedFiltersStore();
    const { setSearchSort } = useSearchSort();
    const { fieldsConfig } = useFiltersConfig();
    const { forgeInstance = 'MLB' } = useMediaConfig();
    const client = useApolloClient();

    const {
        loading,
        data,
        error,
    } = useQuery(
        GET_QUERY_INFO,
        {
            variables: {
                queries,
                queryType,
            },
            skip,
            onCompleted: async(data) => {

                const {
                    filters,
                    sort,
                } = parseQueryInfo(data);

                const contentTagsIndex = filters.findIndex(({ fieldId }) => fieldId === CONTENT_TAGS_FIELD_ID);

                if(contentTagsIndex > -1) {

                    const contentTagsFilter = filters[contentTagsIndex];
                    const contentTagsValues = contentTagsFilter.values;

                    const { data: tagData } = await client.query({
                        query: GET_CONTENT_TAG_DISPLAY_VALUES,
                        variables: {
                            contentTags: contentTagsValues.map(({ value }) => value),
                            forgeInstance,
                        },
                    });

                    const contentTagDisplayValues = _get(tagData, 'contentTagDisplayValues', []);

                    if(contentTagDisplayValues.length) {

                        filters[contentTagsIndex].values = contentTagsValues.map(({ label, value }) => {

                            return {
                                value,
                                label: (contentTagDisplayValues.find(({ slug }) => slug === value))?.displayName || label,
                            };

                        });

                    }

                }

                const filtersOverride = overrideFilters(filters, fieldsConfig);

                setSelectedFilters(filtersOverride);
                setSearchSort(sort);

            },
        }
    );

    return {
        loading,
        data,
        error,
    };

};

export default useQueryInfoQuery;
